Object.defineProperty (module.exports, "__esModule", { value: true });
module.exports.Context3DTextureFormat = module.exports.default = {
	BGR_PACKED: "bgrPacked565",
	BGRA: "bgra",
	BGRA_PACKED: "bgraPacked4444",
	COMPRESSED: "compressed",
	COMPRESSED_ALPHA: "compressedAlpha",
	RGBA_HALF_FLOAT: "rgbaHalfFloat"
};